// extracted by mini-css-extract-plugin
export var linkButton = "GetBambooButton-module--linkButton--872c3";